import { ChangeEvent, useEffect, useState } from "react";
import { MergeWithOverwrite, InputStyle, ValidationErrorStyle } from "src/common";
import { errorA11yProps, errorIdFor } from "src/common/style/a11y.style";
import { InputLabel } from "src/components";

export type InputTextProps = MergeWithOverwrite<React.InputHTMLAttributes<HTMLInputElement>, {
  label?: string;
  value?: string;
  error?: string;
  maxLength?: number;
  className?: string;
  onChange?: (value: string) => void;
  colors?: {
    background?: string;
    text?: string;
  };
}
>;

export const InputText: React.FC<InputTextProps> = ({
  label,
  error = '',
  value = '',
  maxLength = 30,
  onChange,
  className,
  colors,
  ...props
}) => {

  const [inputValue, setInputValue] = useState(value);

  useEffect(() => {
    setInputValue(value);
  }, [value]);

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {

    const input = e.target.value;

    setInputValue(input);
    if (onChange) onChange(input);
  }

  return (
    <div>
      {label ? <InputLabel htmlFor={props.id} disabled={props.disabled}>{label}</InputLabel> : null}
      <InputStyle
        autoComplete="off"
        type='text'
        {...props}
        id={props.id}
        {...errorA11yProps(props.id, error)}
        onChange={handleChange}
        hasError={!!error}
        value={inputValue}
        maxLength={maxLength}
        className={className}
        colors={colors}
      />
      {error ? <ValidationErrorStyle id={errorIdFor(props.id)}>{error}</ValidationErrorStyle> : null}
    </div>
  );
};
